export default "__VITE_ASSET__BuWRfc4G__"